import type { FC } from 'react';

export const StopIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 6 6" fill="none">
    <rect x="1" y="1" width="4" height="4" fill={props.color || '#e6e6e9'} rx="0.8" />
  </svg>
);
